import { render } from "./OrderHistory.vue?vue&type=template&id=09e59944"
import script from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/orderHistory/OrderHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09e59944"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09e59944', __exports__)) {
    console.log('reload')
    api.reload('09e59944', __exports__)
  }
  
  module.hot.accept("./OrderHistory.vue?vue&type=template&id=09e59944", () => {
    console.log('re-render')
    api.rerender('09e59944', render)
  })

}


export default __exports__